(function () {
  // MNR-743: Chatbot-Referral-Attribution.
  // Der Sales-Agent-Chatbot (magnamate) hängt beim Klick auf eine Produktkachel
  // "?ref=magnamate" an die PDP-URL. Landet der Nutzer so auf einer PDP und legt
  // dort das HAUPTPRODUKT in den Warenkorb, markieren wir die Cart-Line mit einer
  // Line-Item-Property (_ref=magnamate), damit der Verkauf im Shopify-Backend als
  // chatbot-getrieben erkennbar ist.
  //
  // NUR Hauptprodukt (Entscheidung Enzo, MNR-743): Cross-Sell-/Complementary-ATCs auf
  // der PDP bekommen die Property NICHT — nur das Produkt, zu dem der Chatbot verlinkt hat.

  if (window.__mnrChatbotReferralInit) return;
  window.__mnrChatbotReferralInit = true;

  // Zentrale Strings — falls sich Chatbot/Analytics auf andere Werte einigen, hier ändern.
  var PARAM_NAME = 'ref';
  var PARAM_VALUE = 'magnamate';
  var PROP_KEY = '_ref';
  var PROP_VALUE = 'magnamate';

  // Ref einmal beim Laden aus der URL lesen.
  var hasRef = false;
  try {
    hasRef = new URLSearchParams(window.location.search).get(PARAM_NAME) === PARAM_VALUE;
  } catch (e) {
    // URLSearchParams sollte überall verfügbar sein; defensiv bleiben.
  }

  if (!hasRef) return;
  window.__mnrChatbotRef = PARAM_VALUE;

  function isMainProductForm(form) {
    var btn = form.querySelector('[data-method]');
    if (!btn) return false;
    var method = btn.getAttribute('data-method');
    return method === 'pdp' || method === 'sticky_cta';
  }

  function injectRefProperty(form) {
    var name = 'items[0][properties][' + PROP_KEY + ']';
    if (form.querySelector('input[name="' + name + '"]')) return; // Doppel-Add vermeiden
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = PROP_VALUE;
    form.appendChild(input);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (!isMainProductForm(form)) return; // nur Hauptprodukt, keine Cross-Sells
      injectRefProperty(form);
    },
    true
  );
})();
